import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';

interface GoogleJsonLoginProps {
    redirectUrl?: string;
}

const GoogleJsonLogin: React.FC<GoogleJsonLoginProps> = ({ redirectUrl = '/student/dashboard' }) => {
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleSuccess = async (credentialResponse: CredentialResponse) => {
        if (credentialResponse.credential) {
            try {
                const response = await fetch('/api/auth/google', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ credential: credentialResponse.credential }),
                });

                if (!response.ok) {
                    throw new Error('Google authentication failed');
                }

                const data = await response.json();
                login(data.token, data.role, data.name);

                // Determine dashboard based on role
                if (data.role === 'admin') {
                    navigate('/admin/dashboard');
                } else {
                    navigate('/student/dashboard');
                }

            } catch (err) {
                setError('Failed to authenticate with backend');
                console.error(err);
            }
        }
    };

    return (
        <div className="w-full">
            <div className="flex justify-center w-full mb-4">
                <GoogleLogin
                    onSuccess={handleSuccess}
                    onError={() => setError('Login Failed')}
                    theme="filled_blue"
                    shape="pill"
                    width="350" // Try to match the width of other buttons
                    logo_alignment="left"
                />
            </div>
            {error && <p className="text-red-500 text-xs text-center mt-2">{error}</p>}
        </div>
    );
};

export default GoogleJsonLogin;
